const SESSION_COOKIE_NAME = "nova_session_expiry";
const SESSION_DURATION_MS = 15 * 60 * 1000; // 15 minutes

const setCookie = (name, value, expiryDate) => {
   const expires = `expires=${expiryDate.toUTCString()}`;
   document.cookie = `${name}=${value};${expires};path=/`;
};

const getCookie = name => {
   const nameEQ = `${name}=`;
   const ca = document.cookie.split(";");
   for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
   }
   return null;
};

const deleteCookie = name => {
   document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

const setSessionExpiryCookie = () => {
   const expiryDate = new Date(Date.now() + SESSION_DURATION_MS);
   setCookie(SESSION_COOKIE_NAME, expiryDate.getTime(), expiryDate);
   return expiryDate;
};

const getSessionExpiryCookie = () => {
   const expiryTimestamp = getCookie(SESSION_COOKIE_NAME);
   if (!expiryTimestamp) return null;
   return new Date(parseInt(expiryTimestamp, 10));
};

const deleteSessionExpiryCookie = () => {
   deleteCookie(SESSION_COOKIE_NAME);
};

const isSessionExpired = () => {
   const expiryDate = getSessionExpiryCookie();
   const hasSessionData =
      sessionStorage.getItem("sessionCurrentStep") !== null ||
      sessionStorage.getItem("indexRegistrationCurrentStep") !== null;
   if (!expiryDate && hasSessionData) return true;
   if (!expiryDate) return false;
   return Date.now() > expiryDate.getTime();
};

const clearAllSessionData = () => {
   sessionStorage.removeItem("sessionCurrentStep");
   sessionStorage.removeItem("sessionStepsState");
   sessionStorage.removeItem("indexRegistrationCurrentStep");
   sessionStorage.removeItem("indexRegistrationStepsState");
   deleteSessionExpiryCookie();
};

export const cookieHelpers = {
   setSessionExpiryCookie,
   getSessionExpiryCookie,
   deleteSessionExpiryCookie,
   isSessionExpired,
   clearAllSessionData,
   SESSION_DURATION_MS,
};
